import axios from "axios";
import {
  AUTH_PERMISSIONS,
  AUTH_PROFILE,
  AUTH_TOKEN,
} from "constants/AuthConstant";
import { eraseCookie } from "./CookieService";
import { API_URL } from "constants/ApiConstant";

export async function autoLogout() {
  try {
    await axios.post(
      API_URL.logout,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        },
      },
    );
  } catch (error) {
    // Optional: log error, tapi jangan hentikan proses logout
    console.error("Logout request failed:", error);
  } finally {
    // Bersihkan data lokal tetap dilakukan
    eraseCookie(AUTH_TOKEN);
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(AUTH_PROFILE);
    localStorage.removeItem(AUTH_PERMISSIONS);
    window.location.href = "/auth/login";
  }
}
